// Utilitaires pour les chaînes de caractères
// Compatible avec les versions antérieures de TypeScript/JavaScript

/**
 * Remplissage d'une chaîne au début avec un caractère spécifié
 * Polyfill pour String.prototype.padStart (ES2017)
 */
export function padStart(str: string, targetLength: number, padString: string = ' '): string {
  if (str.length >= targetLength) {
    return str;
  }
  
  const pad = padString.repeat(Math.ceil((targetLength - str.length) / padString.length));
  return pad.substring(0, targetLength - str.length) + str;
}

/**
 * Remplissage d'une chaîne à la fin avec un caractère spécifié
 * Polyfill pour String.prototype.padEnd (ES2017)
 */
export function padEnd(str: string, targetLength: number, padString: string = ' '): string {
  if (str.length >= targetLength) {
    return str;
  }
  
  const pad = padString.repeat(Math.ceil((targetLength - str.length) / padString.length));
  return str + pad.substring(0, targetLength - str.length);
}

